import React, { useState, useContext, useEffect } from "react";
import "./reportReviewModal.css";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";
import usersRequest from "../../request/usersRequest";

const ReportReviewModalCustomer = ({ open, onClose, reviewId, shopId }) => {
	const { language, userData } = useContext(CombinedContext);

	const [reason, setReason] = useState("");
	const [details, setDetails] = useState("");
	const [emailInput, setEmailInput] = useState("");
	const [loading, setLoading] = useState(false);
	const [toast, setToast] = useState("");

	const isLoggedIn = Boolean(userData?.user?.email);

	useEffect(() => {
		document.body.style.overflow = open ? "hidden" : "";
		return () => {
			document.body.style.overflow = "";
		};
	}, [open]);

	if (!open) return null;

	const t = translations[language].reportReview;

	const reasons = [
		{ id: "spam", label: t.reason.spam },
		{ id: "inappropriate", label: t.reason.inappropriate },
		{ id: "harassment", label: t.reason.harassment },
		{ id: "incorrect", label: t.reason.incorrect },
		{ id: "other", label: t.reason.other },
	];

	async function submitReport() {
		if (!reason) {
			setToast(t.actions.selectReasonError);
			return;
		}

		try {
			setLoading(true);

			const emailToSend = userData?.user?.email || emailInput || null;

			await usersRequest.flagReview(shopId, reviewId, {
				reason,
				message: details,
				email: emailToSend,
			});

			setToast(t.actions.success);

			setTimeout(() => {
				onClose();
			}, 900);
		} catch (err) {
			console.error("Failed to report review:", err);
			setToast(t.actions.error);
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="sf-report-overlay" onClick={onClose}>
			<div className="sf-report-modal" onClick={(e) => e.stopPropagation()}>
				<div className="sf-report-header">
					<h3 className="sf-report-title">{t.title}</h3>
					<button className="sf-report-close" onClick={onClose}>✕</button>
				</div>

				<div className="sf-report-body">
					<p className="sf-report-subtitle">{t.subtitle}</p>

					<select
						className="sf-report-select"
						value={reason}
						onChange={(e) => setReason(e.target.value)}
					>
						<option value="">{t.actions.selectReason}</option>
						{reasons.map((r) => (
							<option key={r.id} value={r.id}>
								{r.label}
							</option>
						))}
					</select>

					<textarea
						className="sf-report-textarea"
						placeholder={t.placeholder}
						value={details}
						onChange={(e) => setDetails(e.target.value)}
					/>

					{!isLoggedIn && (
						<input
							type="email"
							className="sf-report-email-input"
							placeholder={t.actions.emailPlaceholder}
							value={emailInput}
							onChange={(e) => setEmailInput(e.target.value)}
						/>
					)}
				</div>

				<div className="sf-report-footer">
					<button className="sf-report-btn-cancel" onClick={onClose}>
						{t.actions.cancel}
					</button>
					<button
						className="sf-report-btn-submit"
						onClick={submitReport}
						disabled={loading}
					>
						{loading ? t.actions.submitting : t.actions.submit}
					</button>
				</div>

				{toast && <div className="sf-report-toast">{toast}</div>}
			</div>
		</div>
	);
};

export default ReportReviewModalCustomer;